import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { TСreateRequestHHDto } from "../../api/requests/createRequestHH";

type TRequestHHParams = TСreateRequestHHDto;

interface requestHHState {
  requestHHParams: TRequestHHParams | null;
  setRequestHHParams: (params: TRequestHHParams | null) => void;
  clearRequestHHParams: () => void;
}

export const requestHHStore = create<requestHHState>()(
  persist(
    (set) => ({
      requestHHParams: null,
      setRequestHHParams: (params) => {
        set({
          requestHHParams: params,
        });
      },

      clearRequestHHParams: () =>
        set({
          requestHHParams: null,
        }),
    }),
    {
      name: "request-hh-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
